<template>
  <div class="container-xxl flex-grow-1 container-p-y">
    <VouchersGenerate
      v-if="hasPrivilege('vouchers_generate_vouchers') && showAddBatch"
      @updated="applyFilters"
    />
    <div
      class="modal fade"
      id="vouchers-batches-groups-columns"
      tabindex="-1"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-xl modal-dialog-centered modal-simple modal-upgrade-plan"
      >
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>

            <div class="text-center">
              <h4 class="mb-2">
                {{ $t("vouchers_batches.vouchers_batches_columns") }}
              </h4>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="col-xxl-3 col-md-4 col-6 mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="Name"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-cards"></i>
                        <span class="custom-option-title">
                          {{ $t("vouchers_batches.name") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.name.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        id="Name"
                      />
                    </label>
                  </div>
                </div>
                <!-- <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="firstname"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-michelin-star"></i>
                        <span class="custom-option-title">
                          {{ $t("vouchers_batches.currency") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.currency.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        id="firstname"
                      />
                    </label>
                  </div>
                </div> -->
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="lastname"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-square-off"></i>
                        <span class="custom-option-title">
                          {{ $t("vouchers_batches.valid_before") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.valid_before.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        id="lastname"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="Price"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-tags"></i>
                        <span class="custom-option-title">
                          {{ $t("vouchers_batches.user") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.user_email.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        id="Price"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="prefix"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-caret-left"></i>
                        <span class="custom-option-title">
                          {{ $t("vouchers_batches.voucher_value") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.voucher_value.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        id="prefix"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6 mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="lineNumber"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-brand-databricks"></i>
                        <span class="custom-option-title">
                          {{ $t("vouchers_batches.vouchers_count") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.vouchers_count.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        id="lineNumber"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="portNumber"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-ruler-measure"></i>
                        <span class="custom-option-title">
                          {{ $t("vouchers_batches.redeemed_vouchers_count") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.redeemed_vouchers_count.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        id="portNumber"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="portNumber"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-ruler-measure"></i>
                        <span class="custom-option-title">
                          {{ $t("vouchers_batches.expired_vouchers_count") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.expired_vouchers_count.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        id="portNumber"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="portNumber"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-ruler-measure"></i>
                        <span class="custom-option-title">
                          {{ $t("vouchers_batches.canceled_vouchers_count") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.canceled_vouchers_count.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        id="portNumber"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="Notes"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-password"></i>
                        <span class="custom-option-title">
                          {{ $t("vouchers_batches.created_at") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.created_at.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        id="Notes"
                      />
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-datatable">
        <div class="dataTables_wrapper dt-bootstrap5 no-footer">
          <div class="row mx-1" bis_skin_checked="1">
            <div
              class="col-12 col-md-4 d-flex align-items-center justify-content-center justify-content-md-start gap-2 mt-6 mt-md-0 mt-lg-0 mt-xl-0 mt-xxl-0"
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div class="dt-buttons flex" bis_skin_checked="1">
                  <button
                    class="btn btn-primary waves-effect waves-light"
                    type="button"
                    @click.prevent="showAddBatchDialog"
                  >
                    <span>
                      <i class="ti ti-plus ti-xs me-2"></i>
                      <span class=" ">{{
                        $t("vouchers_batches.generate_vouchers")
                      }}</span>
                    </span>
                  </button>
                </div>
              </div>
            </div>
            <div
              class="col-12 col-md-8 d-flex align-items-center justify-content-end flex-column flex-md-row pe-5 gap-2 gap-md-4 mt-4  mt-md-0"
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div class="btn-group" id="dropdown-icon-demo">
                  <button
                    v-if="hasPrivilege('reports_print')"
                    :disabled:="!this.$store.getters.settings.license.active"
                    type="button"
                    class="btn btn-info dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="ti ti-upload ti-xs me-2"></i>
                    {{ $t("control.export") }}
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a
                        href="javascript:void(0);"
                        @click.prevent="print_table('groups_table')"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-printer me-2"></i
                        >{{ $t("control.print") }}</a
                      >
                    </li>
                    <li>
                      <a
                        @click.prevent="
                          export_csv('groups_table', 'batches_groups')
                        "
                        href="javascript:void(0);"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-file me-2"></i
                        >{{ $t("control.csv") }}</a
                      >
                    </li>
                    <li>
                      <a
                        href="javascript:void(0);"
                        @click.prevent="print_table('groups_table')"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-file-text me-2"></i
                        >{{ $t("control.pdf") }}</a
                      >
                    </li>
                  </ul>
                </div>
              </div>

              <div
                id="DataTables_Table_0_filter"
                class="dataTables_filter"
                bis_skin_checked="1"
              >
                <label>
                  <input
                    type="search"
                    class="form-control"
                    @change="applyFilters"
                    :placeholder="$t('control.search')"
                    v-model="filters.search_query"
                    v-if="hasPrivilege('vouchers_view_search_batches')"
                    aria-controls="DataTables_Table_0"
                  />
                </label>
              </div>
            </div>
          </div>
          <div class="row mx-1 mt-n6" bis_skin_checked="1">
            <div
              class="col-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start gap-2"
              bis_skin_checked="1"
            >
              <div
                class="dataTables_length"
                id="DataTables_Table_0_length"
                bis_skin_checked="1"
              >
                <label
                  >{{ $t("control.show") }}
                  <select
                    v-model="filters.rows"
                    @change="applyFilters"
                    name="DataTables_Table_0_length"
                    aria-controls="DataTables_Table_0"
                    class="form-select"
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="500">500</option>
                    <option value="9999999">{{
                      $t("control.rows_all")
                    }}</option>
                  </select>
                </label>
              </div>
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    data-bs-toggle="modal"
                    data-bs-target="#vouchers-batches-groups-columns"
                    class="btn btn-secondary  waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-scan-eye ti-s me-md-2"></i>
                      <span class="d-md-inline-block d-none">{{
                        $t("control.columns_visible")
                      }}</span>
                    </span>
                  </button>
                </div>
              </div>
              <div
                v-if="selection_array.length == 1"
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    @click.prevent="
                      this.$router.push({
                        name: 'VouchersPrint',
                        params: { id: selection_array[0].id },
                      })
                    "
                    class="btn btn-primary  waves-effect waves-light"
                    tabindex="0"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-printer ti-s me-md-2"></i>
                      <span class="d-md-inline-block d-none">{{
                        $t("batches.print_cards")
                      }}</span>
                    </span>
                  </button>
                </div>
              </div>
            </div>

            <div
              class="col-12 col-md-1 d-flex align-items-center justify-content-center justify-content-md-start gap-2 mt-n6 mt-md-0"
              bis_skin_checked="1"
            ></div>

            <div
              class="col-12 col-md-6 d-flex align-items-center justify-content-end flex-column flex-md-row pe-5 gap-2 gap-md-4 mt-n2 mb-6 mb-md-0 mt-md-0"
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    :class="{
                      'btn-primary': autoUpdate,
                      'btn-secondary': !autoUpdate,
                    }"
                    @click.prevent="toggleAutoUpdate"
                    class="btn waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-refresh ti-s me-2"></i>
                      <span class=" ">{{ $t("control.auto_update") }}</span>
                    </span>
                  </button>
                </div>
              </div>
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    :class="{
                      'btn-primary': filters.save,
                      'btn-secondary': !filters.save,
                    }"
                    @click.prevent="toggleSaveFilters"
                    class="btn waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-filter-check ti-s me-2"></i>
                      <span class=" ">{{ $t("control.save_filters") }}</span>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="dataTables_scroll" bis_skin_checked="1">
            <div
              class="dataTables_scrollBody table-container"
              bis_skin_checked="1"
              style="position: relative; overflow: auto; width: 100%; height: 480px;"
            >
              <table
                class="dt-scrollableTable table"
                id="groups_table"
                aria-describedby="DataTables_Table_0_info"
              >
                <thead
                  style="background-color: var(--bs-card-bg);"
                  class="sticky top-0 z-50"
                >
                  <tr class="text-nowrap">
                    <th>
                      <div class="dropdown" v-if="selection_array.length > 1">
                        <button
                          type="button"
                          class="btn p-0 dropdown-toggle hide-arrow"
                          data-bs-toggle="dropdown"
                        >
                          <i class="ti ti-dots-vertical"></i>
                        </button>
                        <ul class="dropdown-menu"></ul>
                      </div>
                    </th>
                    <th>
                      <!-- <input
                        class="form-check-input"
                        type="checkbox"
                        :value="allSelected"
                        @click="checkAll"
                      /> -->
                    </th>
                    <th class="sorting" v-if="columns.name.enabled">
                      {{ $t("vouchers_batches.name") }}
                    </th>
                    <!-- <th class="sorting" v-if="columns.currency.enabled">
                      {{ $t("vouchers_batches.currency") }}
                    </th> -->
                    <th class="sorting" v-if="columns.valid_before.enabled">
                      {{ $t("vouchers_batches.valid_before") }}
                    </th>
                    <th class="sorting" v-if="columns.user_email.enabled">
                      {{ $t("vouchers_batches.user") }}
                    </th>
                    <th class="sorting" v-if="columns.voucher_value.enabled">
                      {{ $t("vouchers_batches.voucher_value") }}
                    </th>
                    <th class="sorting" v-if="columns.vouchers_count.enabled">
                      {{ $t("vouchers_batches.vouchers_count") }}
                    </th>
                    <th
                      class="sorting"
                      v-if="columns.redeemed_vouchers_count.enabled"
                    >
                      {{ $t("vouchers_batches.redeemed_vouchers_count") }}
                    </th>
                    <th
                      class="sorting"
                      v-if="columns.expired_vouchers_count.enabled"
                    >
                      {{ $t("vouchers_batches.expired_vouchers_count") }}
                    </th>
                    <th
                      class="sorting"
                      v-if="columns.canceled_vouchers_count.enabled"
                    >
                      {{ $t("vouchers_batches.canceled_vouchers_count") }}
                    </th>
                    <th class="sorting" v-if="columns.created_at.enabled">
                      {{ $t("control.created_at") }}
                    </th>
                  </tr>
                  <tr v-if="hasPrivilege('vouchers_view_search_batches')">
                    <th></th>
                    <th></th>
                    <th
                      v-if="columns.name.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        @change="applyFilters"
                        v-model="filters.name"
                        type="text"
                        class="form-control"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <!-- <th
                      v-if="columns.currency.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        @change="applyFilters"
                        v-model="filters.currency"
                        type="text"
                        class="form-control"
                        :placeholder="$t('control.search')"
                      />
                    </th> -->
                    <th
                      v-if="columns.valid_before.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        @change="applyFilters"
                        v-model="filters.valid_before"
                        type="text"
                        class="form-control"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th
                      v-if="columns.user_email.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        @change="applyFilters"
                        v-model="filters.user_email"
                        type="text"
                        class="form-control"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th
                      v-if="columns.voucher_value.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    ></th>
                    <th
                      v-if="columns.vouchers_count.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    ></th>
                    <th
                      v-if="columns.redeemed_vouchers_count.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    ></th>
                    <th
                      v-if="columns.expired_vouchers_count.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    ></th>
                    <th
                      v-if="columns.canceled_vouchers_count.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    ></th>
                    <th
                      v-if="columns.created_at.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        @change="applyFilters"
                        v-model="filters.created_at"
                        type="datetime-local"
                        class="form-control"
                        placeholder="YYYY-MM-DD"
                        id="flatpickr-datetime"
                      />
                    </th>
                  </tr>
                </thead>
                <tbody v-if="loading" class="table-border-bottom-0 ">
                  <tr v-for="(item, index) in 10" :key="index">
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th
                      v-for="(item, index) in Object.values(columns).filter(
                        (col) => col?.enabled === true,
                      ).length"
                      :key="index"
                    >
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                  </tr>
                </tbody>
                <tbody class="table-border-bottom-0 " v-if="!loading">
                  <tr v-for="(batch, index) in dataList" :key="batch.id">
                    <th>
                      <div class="dropdown" v-if="selection_array.length <= 1">
                        <button
                          type="button"
                          class="btn p-0 dropdown-toggle hide-arrow"
                          data-bs-toggle="dropdown"
                        >
                          <i class="ti ti-dots-vertical"></i>
                        </button>
                        <ul
                          class="dropdown-menu"
                          :class="{
                            disabled_ssr: !this.$store.getters.settings.license
                              .active,
                          }"
                        >
                          <li
                            v-if="hasPrivilege('vouchers_view_index_batches')"
                          >
                            <button
                              class="dropdown-item text-primary"
                              @click.prevent="
                                this.$router.push({
                                  name: 'BatchVouchers',
                                  params: { id: batch.id },
                                })
                              "
                            >
                              <i class="ti ti-eye me-2"></i
                              >{{ $t("actions.view") }}
                            </button>
                          </li>
                          <li>
                            <button
                              @click.prevent="
                                this.$router.push({
                                  name: 'VouchersPrint',
                                  params: { id: batch.id },
                                })
                              "
                              class="dropdown-item text-success"
                              href="#"
                            >
                              <i class="ti ti-printer me-2"></i
                              >{{ $t("actions.print") }}
                            </button>
                          </li>
                          <li>
                            <button
                              @click="exportCsv(batch.id)"
                              class="dropdown-item text-success"
                              href="#"
                            >
                              <i class="ti ti-printer me-2"></i
                              >{{ $t("actions.export_csv") }}
                            </button>
                          </li>

                          <li v-if="hasPrivilege('vouchers_cancel_batches')">
                            <button
                              @click="showCancelDialog(batch)"
                              class="dropdown-item text-warning"
                              href="#"
                            >
                              <i class="ti ti-discount-off me-2"></i
                              >{{ $t("vouchers_batches.cancel_batch") }}
                            </button>
                          </li>
                          <li v-if="hasPrivilege('vouchers_delete_batches')">
                            <button
                              @click="showDeleteDialog(batch)"
                              class="dropdown-item text-danger"
                              href="#"
                            >
                              <i class="ti ti-trash me-2"></i
                              >{{ $t("vouchers_batches.delete_batch") }}
                            </button>
                          </li>
                        </ul>
                      </div>
                    </th>
                    <td scope="row">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="batch.selected"
                        @click="selectData(batch)"
                      />
                    </td>
                    <td v-if="columns.name.enabled">
                      <a
                        @click.prevent="
                          $router.push(`/vouchers/batches/${batch.id}`)
                        "
                        :href="`/vouchers/batches/${batch.id}`"
                      >
                        {{ batch.name }}
                      </a>
                    </td>
                    <!-- <td v-if="columns.currency.enabled">
                      <span class="badge bg-label-primary me-1">{{
                        batch.currency
                      }}</span>
                    </td> -->
                    <td v-if="columns.valid_before.enabled">
                      {{
                        batch.valid_before
                          ? batch.valid_before
                          : $t("control.none")
                      }}
                    </td>
                    <td v-if="columns.user_email.enabled">
                      {{ batch.user_email }}
                    </td>
                    <td v-if="columns.voucher_value.enabled">
                      <span class="badge bg-label-primary">
                        {{ batch.voucher_value + " " + batch.currency }}
                      </span>
                    </td>
                    <td v-if="columns.vouchers_count.enabled">
                      <span class="badge bg-label-success">
                        {{ batch.vouchers_count }}
                      </span>
                    </td>
                    <td v-if="columns.redeemed_vouchers_count.enabled">
                      <span class="badge bg-label-warning">
                        {{ batch.redeemed_vouchers_count }}
                      </span>
                    </td>
                    <td v-if="columns.expired_vouchers_count.enabled">
                      <span class="badge bg-label-danger">
                        {{ batch.expired_vouchers_count }}
                      </span>
                    </td>
                    <td v-if="columns.canceled_vouchers_count.enabled">
                      <span class="badge bg-label-danger">
                        {{ batch.canceled_vouchers_count }}
                      </span>
                    </td>
                    <td v-if="columns.created_at.enabled">
                      {{ formatDate(batch.created_at) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="row mx-1" bis_skin_checked="1">
            <div class="col-sm-12 col-md-6" bis_skin_checked="1">
              <div
                class="dataTables_info"
                id="DataTables_Table_0_info"
                role="status"
                aria-live="polite"
                bis_skin_checked="1"
              >
                {{
                  $t("control.pagination", {
                    from: meta.from,
                    to: meta.to,
                    total: meta.total,
                  })
                }}
              </div>
            </div>

            <div class="col-sm-12 col-md-6" bis_skin_checked="1">
              <div
                class="dataTables_paginate paging_simple_numbers"
                id="DataTables_Table_0_paginate"
                bis_skin_checked="1"
              >
                <ul class="pagination">
                  <li
                    :class="{ disabled: filters.page < 2 }"
                    class="paginate_button page-item previous"
                    id="DataTables_Table_0_previous"
                  >
                    <a
                      @click.prevent="
                        filters.page = filters.page - 1;
                        applyFilters;
                      "
                      aria-controls="DataTables_Table_0"
                      aria-disabled="true"
                      role="link"
                      data-dt-idx="previous"
                      tabindex="-1"
                      class="page-link"
                    >
                      <i class="ti ti-chevron-left ti-sm"></i>
                    </a>
                  </li>
                  <li
                    class="paginate_button page-item"
                    :class="{
                      active: link.label == filters.page,
                      disabled: link.url == null,
                    }"
                    v-for="(link, index) in meta.links"
                    :key="index"
                  >
                    <a
                      v-if="index != 0 && index < meta.links.length - 1"
                      @click.prevent="
                        filters.page = link.label;
                        applyFilters();
                      "
                      href="#"
                      aria-controls="DataTables_Table_0"
                      role="link"
                      aria-current="page"
                      data-dt-idx="0"
                      tabindex="0"
                      class="page-link"
                      >{{ link.label }}</a
                    >
                  </li>
                  <li
                    :class="{
                      disabled: meta.current_page == meta.last_page,
                    }"
                    class="paginate_button page-item next"
                    id="DataTables_Table_0_next"
                  >
                    <a
                      href="#"
                      aria-controls="DataTables_Table_0"
                      role="link"
                      data-dt-idx="next"
                      tabindex="0"
                      class="page-link"
                    >
                      <i class="ti ti-chevron-right ti-sm"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import { mapGetters } from "vuex";
import {
  export_csv,
  export_pdf,
  hasPrivilege,
  print_table,
} from "../global_constants.js";
import VouchersGenerate from "../components/modals/vouchers-generate.vue";
export default {
  components: { VouchersGenerate },
  computed: {
    ...mapGetters(["user"]),
  },
  name: "VouchersBatches",
  data() {
    return {
      dataList: null,
      meta: { last_page: 0 },
      selectedData: null,
      showContext: false,
      loading: true,
      showFilters: false,
      fullList: false,
      filters: {
        rows: 50,
        page: "",
        save: false,
        name: "",
        currency: "",
        valid_before: "",
        user_email: "",
        created_at: "",
        search_query: null,
      },
      checkedBox: true,
      allSelected: false,
      showColumnsSelect: false,
      columns: {
        name: { name: this.$t("vouchers_batches.name"), enabled: true },
        currency: { name: this.$t("vouchers_batches.currency"), enabled: true },
        valid_before: {
          name: this.$t("vouchers_batches.valid_before"),
          enabled: true,
        },
        user_email: {
          name: this.$t("vouchers_batches.user_email"),
          enabled: true,
        },
        voucher_value: {
          name: this.$t("vouchers_batches.voucher_value"),
          enabled: true,
        },
        vouchers_count: {
          name: this.$t("vouchers_batches.vouchers_count"),
          enabled: true,
        },
        redeemed_vouchers_count: {
          name: this.$t("vouchers_batches.redeemed_vouchers_count"),
          enabled: true,
        },
        canceled_vouchers_count: {
          name: this.$t("vouchers_batches.canceled_vouchers_count"),
          enabled: true,
        },
        expired_vouchers_count: {
          name: this.$t("vouchers_batches.expired_vouchers_count"),
          enabled: true,
        },
        created_at: {
          name: this.$t("vouchers_batches.created_at"),
          enabled: true,
        },
      },
      autoUpdate: false,
      selection_array: [],
      debounce: null,
      showAddBatch: false,
    };
  },
  async created() {
    if (this.$route.query.name) {
      this.filters.name = this.$route.query.name;
    }
    this.prepareFilters();
    this.applyFilters();
    this.prepareColumns();
  },
  methods: {
    hasPrivilege(privilege) {
      return hasPrivilege(this.user, privilege);
    },
    prepareFilters() {
      var filters = localStorage.getItem("vouchers_batches_filters");
      if (filters != null) {
        filters = JSON.parse(filters);
        if (filters.save) this.filters = filters;
        else this.filters.rows = filters.rows;
      }
    },
    prepareColumns() {
      var cols = localStorage.getItem("vouchers_batches_columns");
      if (cols != null) {
        cols = JSON.parse(cols);
        this.columns = {
          name: {
            name: this.$t("vouchers_batches.name"),
            enabled: cols[0].enabled,
          },
          currency: {
            name: this.$t("vouchers_batches.currency"),
            enabled: cols[1].enabled,
          },
          valid_before: {
            name: this.$t("vouchers_batches.valid_before"),
            enabled: cols[2].enabled,
          },
          user_email: {
            name: this.$t("vouchers_batches.user_email"),
            enabled: cols[3].enabled,
          },
          voucher_value: {
            name: this.$t("vouchers_batches.voucher_value"),
            enabled: cols[4].enabled,
          },
          vouchers_count: {
            name: this.$t("vouchers_batches.vouchers_count"),
            enabled: cols[5].enabled,
          },
          redeemed_vouchers_count: {
            name: this.$t("vouchers_batches.redeemed_vouchers_count"),
            enabled: cols[6].enabled,
          },
          created_at: {
            name: this.$t("vouchers_batches.created_at"),
            enabled: cols[7].enabled,
          },
          expired_vouchers_count: {
            name: this.$t("vouchers_batches.expired_vouchers_count"),
            enabled: cols[8] != null ? cols[8].enabled : false,
          },
          canceled_vouchers_count: {
            name: this.$t("vouchers_batches.canceled_vouchers_count"),
            enabled: cols[9] != null ? cols[9].enabled : false,
          },
        };
      }
    },
    async applyFilters() {
      this.loading = true;
      var requestString = "vouchers/batches?filters=1";
      if (this.filters.page != "")
        requestString += `&page=${this.filters.page}`;
      if (this.filters.rows != "")
        requestString += `&rows=${this.filters.rows}`;
      if (this.filters.name != "")
        requestString += `&name=${this.filters.name}`;
      if (this.filters.currency != "")
        requestString += `&currency=${this.filters.currency}`;
      if (this.filters.valid_before != "")
        requestString += `&valid_before=${this.filters.valid_before}`;
      if (this.filters.user_email != "")
        requestString += `&user_email=${this.filters.user_email}`;
      if (this.filters.created_at != null && this.filters.created_at != "")
        requestString += `&created_at=${this.filters.created_at}`;
      if (this.filters.search_query != null && this.filters.search_query != "")
        requestString += `&search_query=${this.filters.search_query}`;
      if (this.sort_col)
        requestString += `&order_by=${this.sort_col}&order_dir=${this.sort_dir}`;
      const response = await axios.get(requestString);
      this.dataList = response.data.data;
      if (this.filters.save)
        localStorage.setItem(
          "vouchers_batches_filters",
          JSON.stringify(this.filters),
        );
      if (this.dataList.length < 1 && this.filters.page != 1) {
        this.filters.page = 1;
        this.applyFilters();
      }
      if (this.sort_col) {
        if (this.sort_dir == "ASC") {
          this.dataList.sort((a, b) =>
            a[this.sort_col] > b[this.sort_col]
              ? 1
              : b[this.sort_col] > a[this.sort_col]
              ? -1
              : 0,
          );
        } else {
          this.dataList.sort((a, b) =>
            a[this.sort_col] < b[this.sort_col]
              ? 1
              : b[this.sort_col] < a[this.sort_col]
              ? -1
              : 0,
          );
        }
      }
      this.meta = response.data.meta;
      this.loading = false;
    },
    async showAddBatchDialog(card = null, operation = "new") {
      this.showAddBatch = true;
      await this.$nextTick();
      var modalElement = document.getElementById("generate-vouchers");
      var modalInstance = new bootstrap.Modal(modalElement);
      modalElement.addEventListener("hide.bs.modal", (event) => {
        this.showAddBatch = false;
      });
      modalInstance.show();
    },
    async showDeleteDialog(batch) {
      this.$swal({
        title:
          this.$t("vouchers_batches.delete_batch_permanently") +
          " " +
          batch.name,
        text: this.$t(
          "vouchers_batches.this_will_delete_batch_and_all_its_cards_permanently_and_you_cannot_get_the_money_back",
        ),
        icon: "question",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_delete_it"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.delete(
              `vouchers/batches/${batch.id}/delete`,
            );
            if (response.status == 200) {
              this.selection_array = [];
              this.applyFilters();
            }
            this.$swal({
              title: this.$t("control.success"),
              text: this.$t(
                "vouchers_batches.batch_has_been_permanently_delete",
              ),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    async showCancelDialog(batch) {
      this.$swal({
        title: this.$t("vouchers_batches.cancel_batch") + " " + batch.name,
        text: this.$t(
          "vouchers_batches.this_will_cancel_batch_and_all_its_cards_permanently",
        ),
        icon: "question",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_delete_it"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.post(
              `vouchers/batches/${batch.id}/cancel`,
            );
            if (response.status == 200) {
              this.selection_array = [];
              this.applyFilters();
            }
            this.$swal({
              title: this.$t("control.success"),
              text: this.$t("vouchers_batches.batch_has_been_canceled"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    formatDate(date) {
      return moment(date).format("yyyy-MM-DD HH:mm");
    },
    openContextMenu(e, data) {
      this.selectedData = data;
      this.$refs.menu.open(e);
    },
    checkAll() {
      if (this.allSelected) {
        this.selection_array = [];
        this.dataList.forEach((element) => {
          element.selected = false;
        });
        this.allSelected = false;
      } else {
        this.selection_array = [];
        this.dataList.forEach((element) => {
          element.selected = true;
          this.selection_array.push(element);
        });
        this.allSelected = true;
      }
    },
    selectData(data) {
      if (data.selected == false) {
        data.selected = true;
        this.selection_array.push(data);
      } else {
        data.selected = false;
        this.selection_array.splice(this.selection_array.indexOf(data), 1);
      }
    },
    updateColumns(updated) {
      localStorage.setItem(
        "vouchers_batches_columns",
        JSON.stringify(Object.values(this.columns)),
      );
    },
    async toggleAutoUpdate() {
      this.autoUpdate = !this.autoUpdate;
      while (this.autoUpdate) {
        this.applyFilters();
        await new Promise((r) => setTimeout(r, 30000));
      }
    },
    printCards() {
      this.$router.push(`/vouchers/batches/${this.selectedData.id}/print`);
      this.$store.commit("changeKey");
    },
    sort(param) {
      this.sort_col = param;
      if (!this.columns[param].sort) {
        this.sort_dir = "ASC";
        Object.entries(this.columns).forEach(([key, val]) => {
          val.sort = false;
        });
        this.columns[param].sort = true;
      } else {
        this.sort_dir = "DESC";
        Object.entries(this.columns).forEach(([key, val]) => {
          val.sort = false;
        });
        this.columns[param].sort = false;
      }
      this.applyFilters();
    },
    exportCsv(id) {
      window.location.href =
        localStorage.getItem("server_api") + `vouchers/batches/${id}/csv`;
    },
    toggleSaveFilters() {
      this.filters.save = !this.filters.save;
      localStorage.setItem(
        "vouchers_batches_filters",
        JSON.stringify(this.filters),
      );
    },
    export_csv(table_id, file_name) {
      return export_csv(table_id, file_name);
    },
    export_pdf(table_id, file_name) {
      return export_pdf(table_id, file_name);
    },
    print_table(id) {
      print_table(id);
    },
  },
};
</script>
